const KEYCODE = {
	TAB: 9,
	ESCAPE: 27,
	SPACE: 32,
	LEFT: 37,
	UP: 38,
	RIGHT: 39,
	DOWN: 40,
};

export default KEYCODE;
